<div>
  <app-network-recycling-facilities-filters *ngIf="years"
    [years]="years"
    (search)="searchData($event)">
  </app-network-recycling-facilities-filters>
  <mat-divider></mat-divider>
  <app-network-recycling-facilities-pie-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [data]="data">
  </app-network-recycling-facilities-pie-chart>
</div>
